import React from 'react';

// The marks of the A3 mold frame: the six punching holes where buildPunchingHolePositions puts
// them for the mold, the frame's border and its four screw holes, as ProcessOrderScreen draws
// them into every printing file (PrintingRunSvg, each switched on its own) and MoldEditScreen
// into its A3 preview (all three, the holes with their rings). The ids are the ones the
// hand-drawn frame carried; the two screens spelled the groups out until chain 12.

const PUNCHING_HOLE_RADIUS = 1.505; // the hole punched through the film
const PUNCHING_HOLE_RING_RADIUS = 2.244; // the ring around it the mold editor's preview shows
const PUNCHING_HOLE_GROUP_IDS = {
  topLeft: 'g6',
  topCenter: 'g5',
  topRight: 'g1',
  bottomLeft: 'g3',
  bottomCenter: 'g2',
  bottomRight: 'g4',
};

export const PunchingHoles = ({ positions, withRings = false }) => (
  <g
    id="g7"
    fill="none"
    fillRule="evenodd"
    stroke="red"
    strokeDasharray="none"
    strokeOpacity="1"
    strokeWidth="0.25"
  >
    {Object.entries(PUNCHING_HOLE_GROUP_IDS).map(([hole, id]) => (
      <g id={id} key={hole}>
        {withRings && (
          <circle
            cx={positions[hole].cx}
            cy={positions[hole].cy}
            r={PUNCHING_HOLE_RING_RADIUS}
            display="inline"
          />
        )}
        <circle
          cx={positions[hole].cx}
          cy={positions[hole].cy}
          r={PUNCHING_HOLE_RADIUS}
          display="inline"
        />
      </g>
    ))}
  </g>
);

export const MoldBorder = () => (
  <rect
    id="rect6017"
    width="376.913"
    height="243.943"
    x="21.502"
    y="26.528"
    fill="none"
    fillRule="evenodd"
    stroke="red"
    strokeDasharray="none"
    strokeOpacity="1"
    strokeWidth="0.5"
    rx="16.5"
  />
);

export const ScrewHoles = () => (
  <g
    id="g8"
    fill="none"
    fillRule="evenodd"
    stroke="red"
    strokeDasharray="none"
    strokeOpacity="1"
    strokeWidth="0.5"
  >
    <circle id="circle6020" cx="30.975" cy="260.983" r="3.983" />
    <circle id="circle6019" cx="388.947" cy="260.983" r="3.983" />
    <circle id="circle6021" cx="388.947" cy="36.041" r="3.983" />
    <circle id="circle6022" cx="30.975" cy="36.041" r="3.983" />
  </g>
);
